import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrudService, leftPad, MessageService, SharedDataService, AclService } from 'elbuild-ui-lib-core';
import { Employee, EmployeeService, Timesheetexception, TimesheetResponse, User } from 'toolbandi-ui-lib';
import Calendar from 'tui-calendar';

// workaround tui-calendar!!!
const offset: number = new Date().getTimezoneOffset();

@Component({
	selector: 'app-agenda',
	templateUrl: './agenda.component.html',
	styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() user: Employee;

	height: string = '100vh';
	calendar: Calendar;
	caltitle: string;
	count: number;
	loggeduser: User;
	calusers: Employee[] = [];
	timesheet: TimesheetResponse;
	schedules: any[] = [];


	constructor(
		private timesheetService: CrudService<Timesheetexception>,
		private employeeService: EmployeeService,
		private sharedDataService: SharedDataService,
		private aclService: AclService,
		private modalService: NgbModal,
		private messageService: MessageService,
		private route: ActivatedRoute,
	) {
	}

	ngOnInit() {
		this.calusers = [this.user];
	}

	ngOnDestroy() {
		if (this.calendar)
			this.calendar.destroy();
	}

	ngAfterViewInit() {

		this.calendar = new Calendar('#calendar', {
			defaultView: 'month',
			useCreationPopup: false,
			useDetailPopup: false,
			taskView: false,
			theme: {
				'common.saturday.color': '#991905',
				'common.holiday.color': '#991905',
				'month.weekend.backgroundColor': '#FFE5E5',
			},
			template: {
				monthMoreTitleDate: function (ev) {
					const d = new Date(ev);
					return d.toLocaleDateString('it', { day: 'numeric', month: 'long', year: 'numeric' });
				},
				monthGridHeaderExceed: function (hiddenSchedules) {
					return `<span class="tui-full-calendar-weekday-grid-more-schedules"> +${hiddenSchedules} </span>`;
				},
				timegridDisplayPrimayTime: function (time) {
					const hours = time.hour.toString();
					const minutes = time.minutes.toString();
					return `${leftPad(hours, 2, '0')}:${leftPad(minutes, 2, '0')}`;
				},
				time: function (schedule: tuiCalendar.ISchedule) {
					const start: any = schedule.start;
					const d: Date = start.toDate();
					const hours = d.getHours().toString();
					const minutes = d.getMinutes().toString();
					return `<b>${leftPad(hours, 2, '0')}:${leftPad(minutes, 2, '0')}</b> ${schedule.title}`;
				},
			},
			month: {
				daynames: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
				startDayOfWeek: 1,
				narrowWeekend: false
			},
		});

		this.calendar.on('beforeCreateSchedule', (event: any) => {
			/*
			const app = new Appuntamento();
			app.inizio = event.start.getTime();
			app.fine = event.end.getTime();
			this.openAppuntamento(app);
			*/
			event.guide.clearGuideElement();
		});

		// this.calendar.on('clickSchedule', (event: tuiCalendar.IEventObject) => {
		// 	this.openAppuntamento(event.schedule.raw, false);
		// });

		this.calendar.on('beforeUpdateSchedule', (event: tuiCalendar.IEventObject) => {
			const app = event.schedule.raw;
			app.inizio = event.start.getTime();
			app.fine = event.end.getTime();
		});

		this.loadTimeSheet();

	}

	updateCaltitle() {
		setTimeout(() => {
			if (this.calendar) {
				this.caltitle = this.calendar.getDate().toDate().toLocaleDateString('it',
					{ month: 'long', year: 'numeric' });
			} else {
				this.caltitle = '';
			}
		}, 100);
	}

	loadTimeSheet() {

		this.updateCaltitle();

		this.calendar.clear();

		this.employeeService.getEmployeeTimeSheet(this.user.id).subscribe((ts: TimesheetResponse) => {
			this.timesheet = ts;
			this.prepareSchedules();
			this.calendar.createSchedules(this.schedules);
			// this.count = ts.length;
		}, ({ error }) => {
			this.messageService.sendError(error, 'Timesheet');
		});
	}

	next() {
		this.calendar.next();
		this.loadTimeSheet();
	}

	prev() {
		this.calendar.prev();
		this.loadTimeSheet();
	}

	today() {
		this.calendar.today();
		this.loadTimeSheet();
	}

	addAppuntamento() {

	}

	private prepareSchedules() {
		// ts.ranges.forEach(task => schedules.push(this.toSchedule(task)));
		// ts.holidays.forEach(task => schedules.push(this.toScheduleHolidays(task)))
		// ts.exceptions.forEach(task => schedules.push(this.toScheduleExceptions(task)))
		const dates = this.getDaysArray(new Date(this.timesheet.ranges[0].start * 1000), new Date(this.timesheet.ranges[0].stop * 1000));
		console.log('%c dates', 'color:#FFB86C', dates);
	}

	private getDaysArray(start, end) {
		const arr = [];
		for (const dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
			arr.push(new Date(dt));
		}
		return arr;
	}

	private toSchedule(appuntamento) {

		// modificare questo metodo per i colori degli appuntamenti nelle celle di calendario

		const start = new Date(appuntamento.inizio);
		const end = new Date(appuntamento.fine);

		// workaround tui-calendar!!!
		start.setMinutes(start.getMinutes() + (offset - start.getTimezoneOffset()));
		end.setMinutes(end.getMinutes() + (offset - end.getTimezoneOffset()));

		const color = '#051c2c';

		// appuntamento.users.forEach(user => {
		// 	if (user.iduser === this.loggeduser.id && !user.stato) {
		// 		color = '#051c2c';
		// 	}
		// });

		const schedule: tuiCalendar.ISchedule = {
			id: appuntamento.id.toString(),
			category: 'time',
			title: appuntamento.titolo,
			body: appuntamento.note,
			start: start,
			end: end,
			color: '#ffffff',
			dragBgColor: color,
			raw: appuntamento,
		};

		// if (appuntamento.esito) {
		// 	if (appuntamento.esito === AppuntamentoEsito.ACCETTATO) {
		// 		schedule.borderColor = '#5cb85c';
		// 		schedule.bgColor = '#5cb85c';
		// 	} else if (appuntamento.esito === AppuntamentoEsito.IN_LAVORAZIONE) {
		// 		schedule.borderColor = '#f0ad4e';
		// 		schedule.bgColor = '#f0ad4e';
		// 	} else if (appuntamento.esito === AppuntamentoEsito.RIFIUTATO) {
		// 		schedule.borderColor = '#d9534f';
		// 		schedule.bgColor = '#d9534f';
		// 	}
		// }

		// if (appuntamento.tipologia) {
		// 	if (appuntamento.tipologia === AppuntamentoTipologia.PROMEMORIA) {
		// 		schedule.borderColor = '#B2B2B2';
		// 		schedule.bgColor = '#B2B2B2';
		// 	}
		// }

		// if (appuntamento.tipo) {
		// 	if (appuntamento.tipo === AppuntamentoTipo.PROMEMORIA) {
		// 		schedule.borderColor = '#B2B2B2';
		// 		schedule.bgColor = '#B2B2B2';
		// 	} else if (appuntamento.tipo === AppuntamentoTipo.PROPOSTA_VENDITA
		// 		|| appuntamento.tipo === AppuntamentoTipo.VISITA_VENDITA || appuntamento.tipo === AppuntamentoTipo.VISITA_VENDITA_ZOOM) {
		// 		schedule.borderColor = '#d9534f';
		// 		schedule.bgColor = '#d9534f';
		// 	} else if (appuntamento.tipo === AppuntamentoTipo.MEETING_ZOOM) {
		// 		schedule.borderColor = '#051c2c';
		// 		schedule.bgColor = '#6eb9eb';
		// 	}
		// }

		// 	const style = `
		//   border-radius: 2px;
		//   margin-right: 8px;
		//   color: ${color};
		//   background-color: ${schedule.bgColor};
		//   border-color: ${schedule.borderColor};
		// `;

		// schedule.customStyle = style;

		return schedule;
	}

}
